/*
 * @Author: lidan
 * @Date: 2021-05-24 11:34:59
 * @LastEditTime: 2021-05-24 11:44:19
 * @LastEditors: lidan
 * @Description: 时效设置 api
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\api\prescription.js
 */
import http from "e6-base-core/axios/config";
/************************时效设置 api******************************* */
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";

const {
  host = "",
  E6_MS_TMS_PERSONALIZE_WEB = ""
} = e6ModuleOrderWaybillProcessApi;

// 保存订单发货时效设置
export function savePrescriptionSetting(data) {
  return http({
    url: `${host}${E6_MS_TMS_PERSONALIZE_WEB}/orderTimeSet/save`,
    method: "post",
    data
  });
}

// 查询订单发货时效设置
export function getOrderRequestTime() {
  return http({
    url: `${host}${E6_MS_TMS_PERSONALIZE_WEB}/personalSet/getOrderRequestTime`,
    method: "get"
  });
}
